import {h, Fragment} from "preact"
import { useAppStateSelector } from "@nosto/preact"
import Sidebar from "./Sidebar"
import ActionToolbar from "./ActionToolbar"
import {updatePageTitle} from '../helpers';

/**
 * ContentWrapper takes a function to render non-empty results in the content area.
 * On loading the Loader is used and for empty results the NoResults component is used.
 */
function ContentWrapper({ type, children }) {
    const {
        countProducts,
        foundProducts,
        loading,
        pageType,
        query,
    } = useAppStateSelector(state => ({ 
        countProducts: state.response.products?.total || 0, 
        foundProducts: state.response.products?.total > 0, 
        loading: state.loading,
        pageType: state.pageType,
        query: state.query,
     }))

     if (pageType === 'search') {
        updatePageTitle(query.query, countProducts)
     }

    return (
        <>
            {pageType === 'search' ? (
                <div class="collection-hero color-scheme-1 gradient">
                    <div class="collection-hero__inner page-width ">
                        <div class="collection-hero__text-wrapper">
                            {/* <h1 class="ss__title collection-hero__title ss__title--has-results mt-14 mb-0 lg:mt-20">
                                {foundProducts ? (
                                    <>Search results for "<span class="ss__query">{query.query}</span>"</>
                                ) : (
                                    <>No results for "<span class="ss__query">{query.query}</span>" found</>
                                )}
                            </h1> */}
                            <h1 class="ss__title collection-hero__title ss__title--has-results mt-14 mb-0 lg:mt-20">
                                {foundProducts && (
                                    <>Search results for "<span class="ss__query">{query.query}</span>"</>
                                )}
                            </h1>
                        </div>
                    </div>
                </div>
            ) : null}
            <div class="ns-collection-page-container">
                {foundProducts ? <ActionToolbar /> : null}
                <div class="ns-serp ns-d-flex ns-flex-column ns-flex-md-row"
                    data-nosto-element={type}>
                    {foundProducts && <Sidebar />}
                    <div
                        class="ns-products-grid-container ns-d-block ns-d-md-inline ns-border-box"
                        style={{ position: loading ? "relative" : "initial" }}>
                        { children({ loading, foundProducts }) }
                    </div>
                </div>
            </div>
        </>
    )
}

export function wrapContent(type, Component) {
    return () => (<ContentWrapper type={type}>{Component}</ContentWrapper>)
}

